// const apiUrl = 'http://localhost:5000/api/';
// const apiUrl = 'http://life-enerji-api.karyasmd.com/api/';
const apiUrl = 'https://scoop-api.life-climate.com/api/';

export default {
  siteName: 'SCOOP',
  siteIcon: 'ion-flash',
  footerText: `Karya SMD © ${new Date().getFullYear()}`,
  enableAnimatedRoute: false,
  nullOrEmptySearchItem: '(YOK)',
  api: {
    core: {
      getCountry: apiUrl + 'core/countries',
      getlevel0: apiUrl + 'core/level0s',
      saveEmissionStatements: apiUrl + 'core/versioning-factors',
      getEmissionStatementsByCategoryKod: apiUrl + 'core/emission-statements',
      getFuelTypes: apiUrl + 'core/fuel-types',
      getFuelTypesFiltered: apiUrl + 'core/fuel-types',
      getLevel2sByLevel1Kod: apiUrl + 'core/level2s',
      getUniqueVersions: apiUrl + 'core/unique-versions',
      getFuelTypeUnits: apiUrl + 'core/fuelTypes/unit',
      getAirports: apiUrl + 'core/airport/search'
    },
    client: {
      checkClientExists: apiUrl + 'clients/check/{taxNo}',
      deleteClient: apiUrl + 'clients/delete/{clientId}',
      getClientById: apiUrl + 'clients/{clientId}',
      getClientByTaxNo: apiUrl + 'clients/tax/{taxNo}',
      saveClient: apiUrl + 'clients/save',
      saveSupplierProjectPlantRelation: apiUrl + 'clients/save/supplier-project-plant',
      saveRestrictedClient: apiUrl + 'clients/save/restricted',
      saveSupplier: apiUrl + 'clients/save/supplier',
      getClients: apiUrl + 'clients',
      saveCustomerSupplierRelation: apiUrl + 'clients/save/customer-supplier',
      saveNaceRelation: apiUrl + 'clients/save/customer-supplier/nace-relation',
      deleteCustomerSupplierRelation: apiUrl + 'clients/delete/customer-supplier',
      inviteSupplierEmail: apiUrl + 'clients/customer-supplier/invite/{clientId}',
      registerSupplierEmail: apiUrl + 'clients/customer-supplier/register/{sourceClientId}',
      saveCustomerSupplierRelationWithJWT: apiUrl + 'clients/save/customer-supplier/{jwt}',
      getNaceRelations: apiUrl + 'clients/nace-relations',

      deletePlant: apiUrl + 'plants/delete/{plantId}',
      getPlantById: apiUrl + 'plants/{plantId}',
      savePlant: apiUrl + 'plants/save',
      getPlants: apiUrl + 'plants',
    },
    users: {
      checkUserExists: apiUrl + 'security/users/exists/{username}',
      postUsers: apiUrl + 'security/users/search',
      postUser: apiUrl + 'security/users',
      saveRestrictedUser: apiUrl + 'security/users/restricted',
      deleteUser: apiUrl + 'security/users/',
      getRestrictedUsers: apiUrl + 'security/restricted-users/search',
      postRestrictedUser: apiUrl + 'security/restricted-users',
      getActiveAuditors: apiUrl + 'security/auditor-users',
      getMenuTree: apiUrl + 'security/menu-tree',
      getMenuQuickSearchList: apiUrl + 'security/menu-tree-quick-search-list'
    },
    security: {
      getNotificationType: apiUrl + 'security/notifications/types',
      getRoles: apiUrl + 'security/roles',
      getUser: apiUrl + 'security/users/',
      getCustomerUser: apiUrl + 'security/user-customer/',
      getAuditorUser: apiUrl + 'security/user-auditor/',
      postAuthenticate: apiUrl + 'security/authenticate',
      logout: apiUrl + 'security/logout',
      postChangePassword: apiUrl + 'security/change-password',
      getLogSources: apiUrl + 'security/logs/sources',
      getLogTypes: apiUrl + 'security/logs/types',
      postLog: apiUrl + 'security/logs/search',
      postSaveLog: apiUrl + 'security/logs',
      postForgotPassword: apiUrl + 'security/forgot-password',
      postNotification: apiUrl + 'security/notifications/search',
      getNotificationByUserId: apiUrl + 'security/users/{userId}/notifications',
      postIsRead: apiUrl + 'security/notifications/{notificationId}/read',
      getGeneratePassword: apiUrl + 'security/generate-password',
      getSessionProperties: apiUrl + 'security/session-properties',
      health: apiUrl + 'security/diagnostics/health'
    },
    file: {
      postExcel: apiUrl + 'files/upload-excel',
      uploadFile: apiUrl + 'files/customers/upload',
      showFile: apiUrl + 'files/customers/download',
      getFilesSearch: apiUrl + 'files/search',
      deleteFileByGuidId: apiUrl + 'files'
    },
    project: {
      getProjects: apiUrl + 'projects',
      saveProject: apiUrl + 'projects/save',
      getUserProjects: apiUrl + 'projects/user',
      getProjectById: apiUrl + 'projects/{projectId}',
      deleteProjectById: apiUrl + 'projects/{projectId}',
      getProjectsByClientIds: apiUrl + 'projects/client-ids',
      pinProject: apiUrl + 'projects/{projectId}/pin',
      getSummaryProject: apiUrl + 'projects/summary/{projectId}',
    },
    emission: {
      approveEmissionsByIds: apiUrl + 'emissions/approve',
      saveEmissionByProjectId: apiUrl + 'emissions/save/{projectId}',
      saveCalculateAndAllocateSupplierEmissions: apiUrl + 'emissions/save/{projectId}/calculate-and-allocate',
      saveEmissionWithLatestVersion: apiUrl + 'emissions/save-with-latest-version/{projectId}',
      getEmissionsByGroupId: apiUrl + 'emissions/{projectId}',
      deleteEmissionById: apiUrl + 'emissions/delete/{emissionId}',
      getProjectComparison: apiUrl + 'emissions/comparison',
      getProjectComparisonPie: apiUrl + 'emissions/comparison/pie/{projectId}',
      saveEmissionStatements: apiUrl + 'emissions/statements',
      saveFuelType: apiUrl + 'emissions/fuel-type/save',
      getFuelTypes: apiUrl + 'emissions/fuel-type',
      getLevel0s: apiUrl + 'emissions/hierarchy/level-0',
      getLevel1s: apiUrl + 'emissions/hierarchy/level-1',
      getLevel2s: apiUrl + 'emissions/hierarchy/level-2',
      exportExcel: apiUrl + 'emissions/export-emissions',
      getHierarchy: apiUrl + 'emissions/hierarchy'
    },
    lookup: {
      getNaceCodes: apiUrl + 'clients/lookup/nace-codes',
      protocolTypes: apiUrl + 'projects/lookup/protocol-types',
      getOrganizationBoundaryMethods: apiUrl + 'clients/lookup/organization-boundary-method'
    }
  },
  timeDisplayFormat: 'HH:mm',
  dateFormat: 'DD-MM-YYYY',
  riskDateFormat: 'YYYY-MM-DD',
  dateFormatAddTime: 'DD-MM-YYYY HH:mm:ss',
  dateFormatAddTimeExtendedAccountPage: 'DD-MM-YYYY HH:mm:ss',
  pastDateIntervals: [
    { key: 'today', formatTextKey: "date.today", text: 'Bugün', diff: 0 },
    { key: 'yesterday', formatTextKey: "date.yesterday", text: 'Dün', diff: -1 },
    { key: 'last3Days', formatTextKey: "date.last3Days", text: 'Son 3 Gün', diff: -3 },
    { key: 'last7Days', formatTextKey: "date.lastWeek", text: 'Son 1 Hafta', diff: -7 },
    { key: 'last30Days', formatTextKey: "date.lastMonth", text: 'Son 1 Ay', diff: -30 },
    { key: 'last90Days', formatTextKey: "date.last3Months", text: 'Son 3 Ay', diff: -90 },
    { key: 'last180Days', formatTextKey: "date.last6Months", text: 'Son 6 Ay', diff: -180 },
    { key: 'last365Days', formatTextKey: "date.lastYear", text: 'Son 1 Yıl', diff: -366 },
  ],
  futureDateIntervals: [
    { key: 'next7Days', text: 'Gelecek 1 Hafta', diff: 7 },
    { key: 'next15Days', text: 'Gelecek 15 Gün', diff: 15 },
    { key: 'next30Days', text: 'Gelecek 1 Ay', diff: 30 },
    { key: 'next90Days', text: 'Gelecek 3 Ay', diff: 90 },
    { key: 'next180Days', text: 'Gelecek 6 Ay', diff: 180 },
  ],
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};
